export default {
      id: "eye-password-show-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#eye-password-show-usage",
      toString: function () {
        return this.url;
      }
    }